export const EEWDSWidgets = [];
